import React from 'react'
import { Switch, Route, Link } from 'react-router-dom'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'
import { MobileAdBundle, SidebarAdBundle } from '@/Layout/Ads'

import FavoritesIndex from '@/pages/Favorites/FavoritesIndex'
import FavoriteRolesIndex from '@/pages/Favorites/FavoriteRolesIndex'

function breadCrumbs() {
  // const location = useLocation()
  // const activePath = location.pathname
  // const [submission] = useGlobalState('submission')
  // will need this ^ when adding show/edit func, see creditscontainer
  const crumbs = [
    { to: '/favorites', name: 'Favorites' }
  ]
  return crumbs
}

function pageTitle() {
  // const location = useLocation()
  // const activePath = location.pathname
  // const [currentUser] = useGlobalState('currentUser')
  // const { id } = useParams()
  // const [submission] = useGlobalState('submission')
  // will need this ^ when adding show/edit func, see creditscontainer

  const titleInfo = {
    title: 'Favorites',
    buttons: []
  }

  return titleInfo
}

export default function FavoritesContainer(props) {
  const crumbs = breadCrumbs()
  const titleInfo = pageTitle()

  return <>
    <Breadcrumbs>
      { crumbs.map((crumb, index) => (
        <Link key={`${index}${crumb.name}`} to={crumb.to} className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 dark:text-gray-100">
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle={titleInfo.title}>
      {titleInfo.buttons}
    </PageTitle>
    <Switch>
      <Route {...props} exact path={['/favorites']}>
        <MobileAdBundle ezoicAdId={110} />
        <div className='xl:block xl:flex xl:gap-x-2'>
          <div className='max-w-6xl w-full space-y-4'>
            <FavoritesIndex />
            <FavoriteRolesIndex />
          </div>
          <SidebarAdBundle ezoicAdId={111} />
        </div>
      </Route>
    </Switch>
  </>
}
